import React from "react"

import { withFontSizeConfig } from "../../../config/FontSizeConfigProvider"
import { cleanSmpSrcLabel } from "../../resources/utils"

function LabelForSeries({
  obs,
  observationTypes,
  download = false,
  labelFontSize, // From FontSizeConfigProvider
}) {
  return (
    <div
      style={{
        float: "left",
        color: "" + (obs.disabled ? "var(--lanzalake-grey)" : "var(--lanzalake-black)"),
        fontSize: `${labelFontSize}px`,
        fontFamily: "Arial",
      }}
    >
      {obs.label || (observationTypes[obs.tag] && observationTypes[obs.tag].tag_label) || obs.tag}
      {obs.smp_src && <span style={{ fontSize: "75%" }}>{` (${cleanSmpSrcLabel(obs)})`}</span>}
      {download && <span style={{ fontSize: "75%" }}>{obs.axis2 ? " [Y2]" : " [Y1]"}</span>}
      {obs.subLabel1 && (
        <div style={{ fontSize: "75%", paddingLeft: "8px" }}>
          <div>
            {obs.subLabel1Descriptor && `${obs.subLabel1Descriptor} = `}
            {obs.subLabel1}
          </div>
          <div>
            {obs.subLabel2Descriptor && `${obs.subLabel2Descriptor} = `}
            {obs.subLabel2}
          </div>
        </div>
      )}
    </div>
  )
}

export default withFontSizeConfig(LabelForSeries)
